import globalStyles from '../../styles/exported.module.scss';
import { svgIconsTestIds } from '../tests/testIds';

export const DownloadIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...(className && { className })}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    data-testid={svgIconsTestIds.downloadIcon}
  >
    <path
      d="M19.8333 13.084L18.5408 11.7915L14.3333 15.9898V5.83398H12.5V15.9898L8.2925 11.7824L7 13.084L13.4167 19.5007L19.8333 13.084Z"
      fill={globalStyles.bdPrimaryBoostedBlue}
    />
    <path d="M7 21.291H19.8333" stroke={globalStyles.bdPrimaryBoostedBlue} strokeWidth="1.5" />
  </svg>
);
